// 仓库承运商账户
import TableList from "@components/templates/tablelist";
import { HttpGetAccountManage } from "@/service/billing";
import { mapGetters } from "vuex";

export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    EQ_accountStatus: null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpGetAccountManage,
        
    },
    computed: {
        ...mapGetters('dictionary',['getNextOrgList','getCarrierServiceList']),
        TabsData(){
            return [
                {
                    name: this.$t('global.common.all', { defaultValue: '全部' }) ,
                    key:'EQ_accountStatus',
                    val: null
                },
                {
                    name: this.$t('fbb.bill.account_common', { defaultValue: '正常' }) ,
                    key:'EQ_accountStatus',
                    val: 0
                }, 
                {
                    name: this.$t('fbb.bill.account_arrearage', { defaultValue: '欠费' }),
                    key:'EQ_accountStatus',
                    val: 1
                }, 
            ]
        },
        SearchsData() {
            return [
                {
                    label:this.$t('fbb.inbound.client_organization', { defaultValue: '客户' }),
                    tag: 'vSelect',
                    key: 'EQ_organizationId',
                    options: this.getNextOrgList,
                    props:{
                        filterable:true,
                    },
                    show: true,
                },
            ]
        },
        columns() {
            return [
            {
                title: this.$t('fbb.bill.account_org', { defaultValue: '账户组织' }),
                key: 'organizationName',
                sortable: true,
            },
            {
                title:   this.$t('fbb.alloment.order_status', { defaultValue: '状态' }),
                key: 'accountStatus',
                render:(h,{row})=>{
                    switch (row.accountStatus) {
                        case 0: return this.$t('fbb.bill.account_common', { defaultValue: '正常' });  break;
                        default: return  this.$t('fbb.bill.account_arrearage', { defaultValue: '欠费' }); break;
                    }
                }
            },
            {
                title: this.$t('fbb.bill.account_freeze', { defaultValue: '冻结总额' })+'(USD)',
                key: 'freezeAmount',
                sortable: true
            },
            {
                title: this.$t('fbb.bill.account_available', { defaultValue: '可用余额' })+'(USD)' ,
                key: 'availableAmount',
                sortable: true
            },
            ];
        },

    },

};
